import api from '../../../services/Api';
import { IAuditoriaFinanceiraResultado } from '../interfaces/IAuditoriaFinanceira';

export const AuditoriaFinanceiraService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaFinanceiraResultado> {
    const response = await api.get<IAuditoriaFinanceiraResultado>('auditoria-financeira/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        creditoTributarioPerdidoTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoResgateIrrf: '',
        fundamentacaoReceitaMensal: '',
        fundamentacaoConciliacao: '',
        resgatesSemIrrf: [],
        receitaMensalAusente: [],
        conciliacaoConsolidada: [],
      }
    );
  },
};
